module.exports = __webpack_public_path__ + "img/MF.94dc90e2.svg";